export default "__VITE_ASSET__PwK41Ws$__"